
















import Alerta from "@/shared/components/alerts.vue";
import Desktop from "@/shared/components/desktop.vue";
import GlobalLoader from "@/shared/components/global-loader.vue";
import GlobalNotification from '@/shared/components/global-notification.vue';
import Mobile from "@/shared/components/mobile.vue";
import Toast from '@/shared/components/toast.vue';
import Store from "@/shared/global-store";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Component, Vue } from "vue-property-decorator";
import { CertificadoInterService } from "./services/certificado-inter.service";
import { GlobalNotificationService } from "./services/global-notification.service";
import { HomeService, Usuario } from "./services/home.service";
import { LoginService } from "./services/login.service";
dayjs.extend(customParseFormat);

const diasAvisoAntesCertificadoExpirar = 15;

@Component({
  components: {
    Desktop,
    Mobile,
    Alerta,
    Toast,
    GlobalLoader,
    GlobalNotification,
  },
})
export default class MainComponent extends Vue {
  state = Store.state;
  usuario: Usuario | null = null;
  isMobile = false;

  async mounted() {
    GlobalNotification.close();

    this.configure();
    window.Date.prototype.toJSON = function () {
      return dayjs(this).format("YYYY-MM-DDTHH:mm:ss");
    };
    dayjs.locale("pt-br");

    this.usuario = await HomeService.Logado();
    if (this.usuario) {
      this.verificarCertificadoInter();
    }
  }

  configure() {
    this.resize();
    window.addEventListener("resize", this.resize);
  }

  resize() {
    this.isMobile = document.documentElement.clientWidth <= 960;
  }

  private async exibirNotificacaoCertificadoInter(message: string) {
    GlobalNotificationService.warning(
      message,
      {
        dismissible: true,
        persistent: true,
        actions: [
          {
            label: "Configurar/Renovar",
            variant: "text",
            action: () => {
              this.$router.push({ path: '/configuracoes/inter' });
            }
          }
        ]
      }
    );
  }

  private async podeVisualizarCertificadoInter() {
    const roles = await LoginService.GetRoleUsuario();
    return roles.findIndex(r => ['Admin', 'Gerente'].includes(r)) !== -1;
  }

  async verificarCertificadoInter() {
    if (!(await this.podeVisualizarCertificadoInter())) {
      return;
    }

    const config = await CertificadoInterService.obterConfiguracao();
    if (!config) {
      return;
    }

    const validade = config.validade;
    if (validade) {
      const diasRestantes = dayjs(validade).diff(dayjs(), 'day');
      if (diasRestantes < diasAvisoAntesCertificadoExpirar) {
        let mensagem = `O certificado Inter irá expirar em ${diasRestantes} dia(s). Por favor, renove o certificado para evitar interrupções nos pagamentos PIX.`;
        if (diasRestantes <= 0) {
          mensagem = "O certificado Inter expirou. Por favor, renove o certificado imediatamente para evitar interrupções nos pagamentos PIX.";
        }

        this.exibirNotificacaoCertificadoInter(mensagem);
      }
    }
  }
}
